import { render, staticRenderFns } from "./PurchaseOrderItemList.vue?vue&type=template&id=19fa2b36&"
import script from "./PurchaseOrderItemList.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItemList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports